import type { FC, ReactNode } from 'react'

import Head from 'next/head'
import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import About from '@/components/landing/about'
import ClientStrip from '@/components/landing/client-strip'
import Contact from '@/components/landing/contact'
import ExistingSite from '@/components/landing/existing-site'
import Faq from '@/components/landing/faq'
import Finished from '@/components/landing/finished'
import Hero from '@/components/landing/hero'
import Paths from '@/components/landing/paths'
import Process from '@/components/landing/process'
import Testimonials from '@/components/landing/testimonials'
import Work from '@/components/landing/work'
import { contact, faqs } from '@/constants/content'
import { siteConfig } from '@/constants/site'

const structuredData = {
    '@context': 'https://schema.org',
    '@graph': [
        {
            '@type': 'ProfessionalService',
            name: siteConfig.name,
            description: siteConfig.description,
            telephone: '+1-817-964-8961',
            email: contact.email,
            areaServed: 'Fort Worth, Texas',
            address: {
                '@type': 'PostalAddress',
                addressLocality: 'Fort Worth',
                addressRegion: 'TX',
                addressCountry: 'US'
            },
            founder: {
                '@type': 'Person',
                name: 'David Mudry',
                jobTitle: 'Web developer',
                sameAs: [contact.linkedin]
            },
            priceRange: '$1,200+'
        },
        {
            '@type': 'FAQPage',
            mainEntity: faqs.map(faq => ({
                '@type': 'Question',
                name: faq.question,
                acceptedAnswer: {
                    '@type': 'Answer',
                    text: faq.answer
                }
            }))
        }
    ]
}

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo />

            <Head>
                <script
                    type='application/ld+json'
                    dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData).replace(/</g, '\\u003c') }}
                />
            </Head>

            <Hero />
            <ClientStrip />
            <Paths />
            <Work />
            <Finished />
            <Testimonials />
            <Process />
            <ExistingSite />
            <About />
            <Faq />
            <Contact />
        </Layout>
    )
}

export default Home
